import script from "./SimpleDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleDialog.vue?vue&type=script&setup=true&lang=js"

import "./SimpleDialog.vue?vue&type=style&index=0&id=6a5f5416&lang=scss"

const __exports__ = script;

export default __exports__